import React, { useState } from "react";

import Dolar3d from "./Dolar3d";

import SocialMedia from "./SocialMedia";

import "./global.css";

import { AppBar, Container } from "@mui/material";

function App() {
  return (
    <div>
      <AppBar
        position="static"
        sx={{
          background:
            "linear-gradient(90deg, rgba(2,0,36,1) 32%, rgba(16,71,37,1) 45%, rgba(100,50,58,1) 100%)",
        }}
      ></AppBar>
      <Container>
        {/* <DatosDesdeAPI /> */}
        <Dolar3d />

        <SocialMedia />

        {/* <Reloj /> */}
      </Container>
    </div>
  );
}

export default App;
